import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSideDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 420,
	height: 900,
	viewBox: "0 0 420 900",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	preserveAspectRatio: "xMinYMin slice",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6812_95632)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 420,
				height: 900,
				transform: "matrix(-1 0 0 1 420 0)",
				fill: "url(#paint0_radial_6812_95632)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M121.797 289.6C127.992 289.6 133.014 294.549 133.014 300.653C133.014 306.757 127.992 311.706 121.797 311.706C115.602 311.706 110.58 306.757 110.58 300.653C110.58 294.549 115.602 289.6 121.797 289.6Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M121.797 295.862C124.488 295.862 126.67 298.007 126.67 300.653C126.67 303.299 124.488 305.444 121.797 305.444C119.105 305.444 116.924 303.299 116.924 300.653C116.924 298.007 119.105 295.862 121.797 295.862Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.4061 234C49.0973 234 51.279 236.145 51.279 238.791C51.279 241.437 49.0973 243.582 46.4061 243.582C43.7149 243.582 41.5332 241.437 41.5332 238.791C41.5332 236.145 43.7149 234 46.4061 234Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M412.901 403.124C419.096 403.124 424.118 408.073 424.118 414.177C424.118 420.281 419.096 425.229 412.901 425.229C406.706 425.229 401.684 420.281 401.684 414.177C401.684 408.073 406.706 403.124 412.901 403.124Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M412.9 409.386C415.591 409.386 417.773 411.531 417.773 414.177C417.773 416.823 415.591 418.968 412.9 418.968C410.209 418.968 408.027 416.823 408.027 414.177C408.027 411.531 410.209 409.386 412.9 409.386Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M215.42 234.675C221.615 234.675 226.637 239.623 226.637 245.727C226.637 251.832 221.615 256.78 215.42 256.78C209.225 256.78 204.203 251.832 204.203 245.727C204.203 239.623 209.225 234.675 215.42 234.675Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M215.42 240.936C218.111 240.936 220.293 243.081 220.293 245.727C220.293 248.373 218.111 250.518 215.42 250.518C212.729 250.518 210.547 248.373 210.547 245.727C210.547 243.081 212.729 240.936 215.42 240.936Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M280.199 345.242C286.395 345.242 291.417 350.19 291.417 356.294C291.417 362.399 286.395 367.347 280.199 367.347C274.004 367.347 268.982 362.399 268.982 356.294C268.982 350.19 274.004 345.242 280.199 345.242Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M280.199 351.503C282.89 351.503 285.072 353.648 285.072 356.294C285.072 358.94 282.89 361.085 280.199 361.085C277.508 361.085 275.326 358.94 275.326 356.294C275.326 353.648 277.508 351.503 280.199 351.503Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M332.746 326.146C338.941 326.146 343.963 331.095 343.963 337.199C343.963 343.303 338.941 348.252 332.746 348.252C326.551 348.252 321.529 343.303 321.529 337.199C321.529 331.095 326.551 326.146 332.746 326.146Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M332.746 332.408C335.437 332.408 337.619 334.553 337.619 337.199C337.619 339.845 335.437 341.99 332.746 341.99C330.055 341.99 327.873 339.845 327.873 337.199C327.873 334.553 330.055 332.408 332.746 332.408Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-11 254.673L41.5 241.205",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.1035 248.143L115.371 291.207",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.232 294.675L205.945 252.367",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M220.359 255.606L273.853 347.887",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M289.795 349.98L322.204 341.005",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M406.854 404.595L340.092 345.472",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M258.905 157.326C273.56 180.914 272.463 211.028 256.13 233.472L192.667 320.684L123.147 403.144C105.256 424.365 76.2855 432.614 49.8929 424.001L-52.6615 390.535L-152.573 349.84C-178.285 339.367 -195.092 314.351 -195.071 286.584L-194.99 178.689L-187.218 71.0781C-185.218 43.3841 -166.636 19.6747 -140.23 11.1263L-37.6257 -22.0903L67.0887 -47.9025C94.0373 -54.5454 122.329 -44.1823 138.628 -21.6984L201.96 65.6674L258.905 157.326Z",
				fill: "url(#paint1_radial_6812_95632)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M121.797 640.862C127.992 640.862 133.014 645.811 133.014 651.915C133.014 658.019 127.992 662.968 121.797 662.968C115.602 662.968 110.58 658.019 110.58 651.915C110.58 645.811 115.602 640.862 121.797 640.862Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M121.797 647.124C124.488 647.124 126.67 649.269 126.67 651.915C126.67 654.561 124.488 656.706 121.797 656.706C119.105 656.706 116.924 654.561 116.924 651.915C116.924 649.269 119.105 647.124 121.797 647.124Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.4065 579C52.6015 579 57.6236 583.948 57.6236 590.053C57.6236 596.157 52.6015 601.105 46.4065 601.105C40.2115 601.105 35.1895 596.157 35.1895 590.053C35.1895 583.948 40.2115 579 46.4065 579Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.4061 585.262C49.0973 585.262 51.279 587.407 51.279 590.053C51.279 592.699 49.0973 594.844 46.4061 594.844C43.7149 594.844 41.5332 592.699 41.5332 590.053C41.5332 587.407 43.7149 585.262 46.4061 585.262Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M412.901 754.386C419.096 754.386 424.118 759.334 424.118 765.438C424.118 771.543 419.096 776.491 412.901 776.491C406.706 776.491 401.684 771.543 401.684 765.438C401.684 759.334 406.706 754.386 412.901 754.386Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M412.9 760.648C415.591 760.648 417.773 762.792 417.773 765.438C417.773 768.084 415.591 770.229 412.9 770.229C410.209 770.229 408.027 768.084 408.027 765.438C408.027 762.792 410.209 760.648 412.9 760.648Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M215.42 585.936C221.615 585.936 226.637 590.885 226.637 596.989C226.637 603.093 221.615 608.042 215.42 608.042C209.225 608.042 204.203 603.093 204.203 596.989C204.203 590.885 209.225 585.936 215.42 585.936Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M215.42 592.198C218.111 592.198 220.293 594.343 220.293 596.989C220.293 599.635 218.111 601.78 215.42 601.78C212.729 601.78 210.547 599.635 210.547 596.989C210.547 594.343 212.729 592.198 215.42 592.198Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M280.199 696.503C286.395 696.503 291.417 701.452 291.417 707.556C291.417 713.66 286.395 718.609 280.199 718.609C274.004 718.609 268.982 713.66 268.982 707.556C268.982 701.452 274.004 696.503 280.199 696.503Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M280.199 702.765C282.89 702.765 285.072 704.91 285.072 707.556C285.072 710.202 282.89 712.347 280.199 712.347C277.508 712.347 275.326 710.202 275.326 707.556C275.326 704.91 277.508 702.765 280.199 702.765Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M332.746 677.408C338.941 677.408 343.963 682.356 343.963 688.461C343.963 694.565 338.941 699.513 332.746 699.513C326.551 699.513 321.529 694.565 321.529 688.461C321.529 682.356 326.551 677.408 332.746 677.408Z",
				stroke: "#353537",
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M332.746 683.67C335.437 683.67 337.619 685.815 337.619 688.461C337.619 691.107 335.437 693.251 332.746 693.251C330.055 693.251 327.873 691.107 327.873 688.461C327.873 685.815 330.055 683.67 332.746 683.67Z",
				fill: "#233E30"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-11 606.044L35.8795 593.871",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.1035 599.405L115.371 642.469",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.232 645.937L205.945 603.629",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M220.359 606.868L273.853 699.149",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M289.795 701.241L322.204 692.267",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M406.854 755.857L340.092 696.734",
				stroke: "#353537",
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M630.744 783.799C633.141 811.466 618.538 837.825 593.818 850.451L497.763 899.513L398.457 941.596C372.901 952.427 343.333 946.675 323.693 927.053L247.377 850.809L176.689 769.313C158.497 748.34 154.827 718.427 167.409 693.673L216.297 597.49L271.916 505.04C286.229 481.247 313.528 468.511 340.944 472.834L447.475 489.635L552.537 513.992C579.575 520.261 600.117 542.303 604.479 569.728L621.431 676.295L630.744 783.799Z",
				fill: "#232324"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M225.164 987.934C225.164 987.934 172.681 1027.92 136.355 966.428C136.355 966.428 109.225 941.867 129.528 915.387C129.528 915.387 117.19 887.721 144.23 868.689C144.23 868.689 147.672 831.157 186.431 816.127C186.431 816.127 206.251 780.358 245.072 780.154C245.072 780.154 259.492 761.964 279.853 771.88C279.853 771.88 315.362 748.264 345.269 773.45C345.269 773.45 373.142 765.934 385.864 791.943C385.864 791.943 438.053 801.903 445.108 856.226C445.108 856.226 449.23 891.036 421.474 911.213C421.474 911.213 433.429 940.538 399.835 961.539C399.835 961.539 390.477 970.692 378.699 973.37C365.372 976.391 352.358 967.106 350.264 953.613C350.264 953.613 306.602 987.978 289.552 995.811C272.501 1003.64 245.329 1010.01 225.155 987.94L225.164 987.934Z",
				fill: "#4E3C0E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M226.073 985.757C217.92 975.476 215.247 961.096 219.15 948.563C223.054 936.03 233.42 925.708 245.968 921.852C249.818 920.669 254.131 919.893 256.744 916.828C258.465 914.823 259.126 912.159 259.931 909.649C265.038 893.636 277.721 880.226 293.422 874.228C286.657 866.676 283.85 855.745 286.164 845.857",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M146.531 869.597C141.872 879.63 144.462 892.545 152.62 899.996C160.779 907.447 173.876 908.876 183.456 903.328",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.764 872.855C237.627 864.344 236.492 852.269 230.895 843.57C225.307 834.867 212.987 830.763 203.758 835.444C198.999 837.856 195.448 842.143 192.709 846.73",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M262.168 846.252C257.284 839.066 256.312 829.385 259.656 821.361C263 813.337 270.573 807.221 279.126 805.63C274.186 801.781 271.134 795.627 271.052 789.366C270.978 783.099 273.878 776.87 278.726 772.897",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M300.504 824.193C307.06 820.23 315.21 819.013 322.633 820.881C330.055 822.749 336.647 827.693 340.529 834.295",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M334.086 799.205C341.116 791.691 352.273 788.314 362.284 790.68C372.289 793.038 380.763 801.051 383.676 810.901C389.098 807.609 396.238 807.929 401.895 810.791C407.552 813.653 411.82 818.777 414.671 824.433C419.686 834.376 420.606 846.303 417.166 856.895C413.726 867.487 405.978 876.613 396.071 881.717",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M247.478 777.626C243.098 781.624 240.158 787.181 239.322 793.05C238.486 798.918 239.761 805.07 242.854 810.134",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.097 965.797C269.265 961.964 287.333 956.933 303.855 948.451C320.378 939.969 335.359 927.827 345.022 911.975C354.685 896.123 358.624 876.362 353.441 858.536",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M355.602 883.42C361.545 879.631 369.288 878.84 375.868 881.357",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M201.385 836.368C199.423 833.484 198.158 830.128 197.736 826.673",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M355.618 867.104C355.815 866.479 356.012 865.855 356.209 865.23C365.066 875.266 365.223 890.889 359.607 903.758C353.992 916.627 343.501 927.161 332.382 936.277C321.233 945.425 309.062 953.583 295.706 958.985C282.349 964.386 267.699 966.914 253.915 964.679C253.915 964.679 287.619 959.501 322.285 934.282C356.946 909.055 355.609 867.109 355.609 867.109L355.618 867.104Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M217.19 960.15C216.537 946.967 216.147 936.592 222.829 927.191C229.511 917.79 240.599 911.678 252.105 911.031C254.011 901.079 259.21 891.774 266.695 884.929C274.18 878.085 283.9 873.721 293.985 872.701C286.919 876.984 279.815 881.303 273.715 886.878C267.616 892.452 262.54 899.43 260.567 907.453C259.719 910.895 259.657 912.695 257.56 915.548C254.656 919.479 250.034 921.072 245.296 922.285C229.377 926.327 218.058 942.077 217.19 960.15Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M436.178 865.624C432.166 882.507 422.142 897.899 408.324 908.397C416.716 915.849 419.084 928.585 416.041 939.381C414.167 946.057 410.512 952.037 405.909 957.264C431.891 936.776 421.478 911.209 421.478 911.209C449.225 891.037 445.112 856.222 445.112 856.222C443.578 844.409 439.903 834.693 435.097 826.712C438.785 839.307 439.219 852.847 436.187 865.619L436.178 865.624Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M415.274 823.126C424.677 831.255 428.797 845.012 425.393 856.975C421.99 868.938 411.247 878.48 398.968 880.455C398.968 880.455 413.157 870.472 417.163 856.909C422.049 840.385 415.274 823.126 415.274 823.126Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M232.392 845.998C236.14 852.365 236.615 860.546 233.645 867.309C230.675 874.071 224.319 879.256 217.092 880.813L219.078 880.819C227.46 881.696 236.103 876.391 239.117 868.524C242.126 860.649 239.226 850.938 232.397 846.007L232.392 845.998Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M279.012 661.112C276.461 667.466 266.151 682.649 260.553 686.592C258.945 687.728 256.892 688.759 255.088 687.975C253.797 687.412 253.039 686.065 252.602 684.727C251.44 681.214 251.868 677.41 251.978 673.712C252.3 663.033 249.809 652.283 244.831 642.831L273.804 639.976L279.018 661.113L279.012 661.112Z",
				fill: "#5C4610"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M279.035 661.112C276.483 667.466 266.174 682.649 260.576 686.592C258.968 687.728 256.915 688.759 255.11 687.975C253.82 687.412 253.061 686.065 252.624 684.727C251.463 681.214 251.891 677.409 252.001 673.712C252.323 663.033 249.831 652.283 244.854 642.831L273.826 639.976L279.041 661.113L279.035 661.112Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M196.723 609.674C196.723 609.674 156.508 605.8 165.778 563.061C165.778 563.061 163.811 540.739 183.949 537.292C183.949 537.292 189.919 519.731 209.984 522.432C209.984 522.432 227.147 507.005 250.811 516.381C250.811 516.381 274.597 508.56 292.121 524.621C292.121 524.621 306.167 522.45 311.188 535.376C311.188 535.376 336.965 539.542 339.92 563.3C339.92 563.3 355.568 571.522 350.461 588.498C350.461 588.498 369.76 614.688 350.326 642.026C350.326 642.026 337.694 659.377 316.83 656.892C316.83 656.892 309.998 675.04 286.17 670.495C286.17 670.495 278.157 670.713 271.752 667.015C264.509 662.828 262.526 653.242 267.2 646.309C267.2 646.309 233.288 643.579 222.37 640.003C211.451 636.427 196.596 627.981 196.717 609.673L196.723 609.674Z",
				fill: "#715613"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M198.04 609.072C198.655 601.061 203.437 593.489 210.406 589.484C217.374 585.478 226.326 585.155 233.566 588.644C235.788 589.714 238.049 591.16 240.498 590.871C242.105 590.686 243.51 589.764 244.917 588.972C253.873 583.903 265.15 583.157 274.699 586.995C274.802 580.788 278.09 574.71 283.243 571.231",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M183.734 552.052C174.464 558.218 171.064 571.194 174.631 581.736C178.198 592.277 187.724 600.165 198.361 603.455",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.644 523.798C204.376 526.366 200.166 533.245 200.73 539.987C201.295 546.729 206.584 552.82 213.196 554.314",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M246.672 559.897C253.745 559.344 258.26 553.448 259.365 547.212C260.476 540.977 256.649 534.008 250.556 532.27C247.415 531.373 244.036 531.822 240.897 532.743",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M272.307 561.43C273.103 556.169 276.694 551.416 281.535 549.203C286.376 546.99 292.323 547.394 296.827 550.238C296.209 546.454 297.399 542.42 299.967 539.573C302.541 536.727 306.435 535.135 310.267 535.368",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M298.699 567.467C303.293 568.415 307.461 571.259 310.018 575.187C312.575 579.114 313.479 584.078 312.476 588.659",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M324.181 570.218C330.465 569.767 336.883 572.892 340.395 578.121C343.908 583.343 344.38 590.468 341.591 596.105C345.396 596.882 348.47 599.997 349.821 603.636C351.171 607.276 350.956 611.354 349.883 615.08C347.999 621.634 343.45 627.374 337.497 630.701C331.544 634.027 324.267 634.903 317.693 633.074",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M294.254 524.485C290.623 524.459 286.99 525.731 284.173 528.02C281.355 530.308 279.369 533.602 278.651 537.164",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M217.581 610.523C227.337 616.36 237.547 621.618 248.498 624.683C259.449 627.747 271.231 628.527 282.167 625.426C293.104 622.326 303.096 615.088 308.185 604.924",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M298.81 616.999C303.056 617.77 306.864 620.636 308.772 624.505",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M266.203 647.295C277.409 642.882 290.645 644.009 300.944 650.254",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224.635 585.506C226.898 582.937 228.114 579.477 227.951 576.058C227.794 572.64 226.256 569.307 223.766 566.963",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M249.101 531.696C249.419 529.584 250.247 527.55 251.495 525.823",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M305.6 609.679C305.949 609.48 306.297 609.281 306.645 609.083C306.448 617.276 300.018 624.359 292.141 627.804C284.264 631.248 275.169 631.615 266.38 631.084C257.566 630.554 248.704 629.154 240.457 626.023C232.21 622.892 224.577 617.932 219.315 611.193C219.315 611.193 236.61 622.891 262.675 625.986C288.741 629.076 305.594 609.677 305.594 609.677L305.6 609.679Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M204.695 593.877C209.887 587.684 214.029 582.861 220.942 581.418C227.855 579.976 235.379 581.844 240.817 586.34C245.814 582.663 252.022 580.646 258.232 580.686C264.441 580.726 270.624 582.81 275.578 586.549C270.622 585.532 265.634 584.516 260.574 584.482C255.515 584.449 250.332 585.471 246.107 588.254C244.294 589.448 243.517 590.23 241.388 590.639C238.448 591.197 235.709 589.989 233.076 588.563C224.243 583.755 212.605 586.12 204.695 593.877Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M342.406 642.532C333.579 648.447 322.671 651.19 312.096 650.157C312.765 656.996 308.53 663.702 302.67 667.286C299.051 669.505 294.921 670.67 290.678 671.103C310.875 672.711 316.835 656.893 316.835 656.893C337.692 659.377 350.331 642.026 350.331 642.026C354.557 636.082 356.949 630.188 358.111 624.603C354.527 631.795 349.088 638.058 342.412 642.534L342.406 642.532Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M350.706 614.739C351.547 622.303 347.673 630.196 341.167 634.154C334.66 638.112 325.864 637.929 319.527 633.707C319.527 633.707 330.054 635.126 337.497 630.7C346.567 625.31 350.706 614.739 350.706 614.739Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M259.026 548.926C258.06 553.346 254.87 557.218 250.722 559.02C246.574 560.822 241.562 560.506 237.667 558.199L238.557 559.028C241.957 562.91 248.047 564.123 252.674 561.843C257.303 559.557 260.04 553.988 259.025 548.932L259.026 548.926Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.1339 891.579C60.7086 900.263 72.4106 921.531 79.2958 927.416C81.2726 929.11 83.8495 930.721 86.3227 929.912C88.0912 929.33 89.257 927.649 89.9979 925.941C91.9609 921.459 91.8673 916.395 92.1794 911.513C93.0744 897.409 97.6839 883.56 105.407 871.727L67.6037 864.388L58.1255 891.58L58.1339 891.579Z",
				fill: "#5C4610"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M58.1334 891.579C60.7081 900.263 72.4101 921.531 79.2953 927.416C81.2721 929.11 83.849 930.721 86.3222 929.912C88.0908 929.33 89.2565 927.649 89.9975 925.941C91.9604 921.459 91.8668 916.395 92.1789 911.513C93.0739 897.409 97.6834 883.56 105.406 871.727L67.6032 864.388L58.125 891.58L58.1334 891.579Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.856 834.003C172.856 834.003 226.297 833.869 219.368 776.439C219.368 776.439 224.716 747.285 198.621 740.258C198.621 740.258 192.929 716.392 166.17 717.472C166.17 717.472 145.473 695.034 113.15 704.458C113.15 704.458 82.7908 691.22 57.7284 710.207C57.7284 710.207 39.4987 705.613 31.2902 722.016C31.2902 722.016 -3.17163 724.318 -9.99778 755.241C-9.99778 755.241 -31.6215 764.136 -26.9925 787.124C-26.9925 787.124 -55.6445 819.23 -33.4276 857.634C-33.4276 857.634 -18.9351 882.046 8.84819 881.35C8.84819 881.35 15.6034 906.094 47.546 903.053C47.546 903.053 58.071 904.329 66.9631 900.25C77.0195 895.63 80.8147 883.251 75.5163 873.543C75.5163 873.543 120.514 874.137 135.335 870.777C150.155 867.416 170.762 858.129 172.865 834.002L172.856 834.003Z",
				fill: "#604911"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M171.199 833.047C171.378 822.421 166.015 811.859 157.333 805.723C148.651 799.587 136.902 798.055 126.935 801.756C123.877 802.891 120.721 804.516 117.532 803.832C115.438 803.39 113.701 802.003 111.947 800.786C100.778 793.004 86.0187 790.628 72.9695 794.504C73.6003 786.316 70.0213 777.905 63.6641 772.687",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.089 759.723C208.535 768.989 211.409 786.498 205.41 799.939C199.41 813.381 185.89 822.593 171.475 825.611",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M165.144 719.189C173.081 723.345 177.776 732.924 176.199 741.734C174.623 750.543 166.905 757.911 158.013 759.061",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M113.23 762.279C103.983 760.678 98.7656 752.356 98.0805 744.006C97.387 735.658 103.288 726.952 111.527 725.417C115.775 724.624 120.17 725.632 124.19 727.232",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.2817 761.131C78.883 754.105 74.7404 747.402 68.6385 743.889C62.5366 740.377 54.6555 740.174 48.3725 743.363C49.6533 738.456 48.5846 732.996 45.5544 728.929C42.5158 724.864 37.5838 722.287 32.5098 722.12",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.7734 765.821C37.6062 766.501 31.7664 769.732 27.9137 774.589C24.061 779.446 22.2576 785.871 23.0126 792.028",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.87882 766.296C1.65872 764.926 -7.17863 768.249 -12.4501 774.701C-17.7224 781.144 -19.2243 790.47 -16.247 798.238C-21.3538 798.791 -25.7875 802.513 -28.0155 807.139C-30.2435 811.765 -30.4643 817.163 -29.5116 822.203C-27.8402 831.066 -22.5576 839.189 -15.1293 844.305C-7.70091 849.421 1.77477 851.473 10.6582 849.876",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.9352 709.766C59.7203 710.179 64.3475 712.304 67.7751 715.666C71.2027 719.028 73.4123 723.611 73.918 728.391",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M145.286 832.544C131.717 839.027 117.622 844.69 102.821 847.373C88.0199 850.057 72.4076 849.627 58.3877 844.193C44.3679 838.759 32.1035 827.993 26.6568 813.979",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.5059 831.04C31.8189 831.531 26.4505 834.835 23.4593 839.694",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.7102 874.966C62.4972 867.77 44.927 867.619 30.5916 874.571",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M139.086 798.726C136.423 795.064 135.249 790.356 135.886 785.873C136.515 781.391 138.952 777.192 142.521 774.414",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M113.513 724.839C113.354 722.019 112.515 719.238 111.084 716.808",
				stroke: "#1C1C1E",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M29.469 820.561C29.0347 820.256 28.6004 819.951 28.166 819.647C27.4139 830.462 35.0064 840.584 44.9548 846.093C54.9033 851.603 66.8361 853.209 78.4754 853.595C90.149 853.986 101.993 853.238 113.241 850.134C124.489 847.029 135.154 841.439 142.916 833.214C142.916 833.214 118.694 846.483 83.9852 847.34C49.2752 848.189 29.4774 820.56 29.4774 820.56L29.469 820.561Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M164.314 812.214C158.241 803.416 153.382 796.553 144.456 793.799C135.53 791.045 125.391 792.576 117.674 797.826C111.547 792.366 103.621 788.943 95.4383 788.229C87.2553 787.514 78.8559 789.495 71.8691 793.806C78.5217 793.08 85.2169 792.358 91.8841 792.939C98.5514 793.519 105.251 795.506 110.471 799.693C112.711 801.489 113.638 802.616 116.391 803.417C120.194 804.515 123.951 803.263 127.594 801.709C139.821 796.469 154.855 801.021 164.314 812.214Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-23.0587 859.28C-12.1645 868.159 1.86097 873.12 15.9156 873.065C14.1897 881.989 18.9394 891.344 26.2131 896.787C30.7055 900.157 36.0005 902.202 41.5344 903.296C14.7382 902.918 8.84274 881.351 8.84274 881.351C-18.9322 882.045 -33.433 857.634 -33.433 857.634C-38.2645 849.283 -40.6867 841.226 -41.5272 833.727C-37.6953 843.642 -31.3066 852.562 -23.0671 859.281L-23.0587 859.28Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-30.5503 821.651C-32.5926 831.509 -28.4667 842.383 -20.3869 848.4C-12.3071 854.416 -0.700143 855.26 8.16764 850.483C8.16764 850.483 -5.87187 851.052 -15.1276 844.304C-26.4063 836.085 -30.5503 821.651 -30.5503 821.651Z",
					fill: "#1C1C1E"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M98.3125 746.305C99.0384 752.245 102.762 757.739 108.002 760.625C113.242 763.51 119.882 763.713 125.296 761.156L124.021 762.138C119.064 766.83 110.894 767.675 105.082 764.101C99.2688 760.519 96.3513 752.847 98.3133 746.313L98.3125 746.305Z",
					fill: "#1C1C1E"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_6812_95632",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(343.269 891.705) rotate(-108.263) scale(848.38 1151.2)",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#232324" }), /* @__PURE__ */ _jsx("stop", {
				offset: .627605,
				stopColor: "#19191A"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_6812_95632",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(254.254 337.779) rotate(-151.938) scale(519.316 1113.1)",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#232324" }), /* @__PURE__ */ _jsx("stop", {
				offset: .627605,
				stopColor: "#19191A"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6812_95632",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 420,
				height: 900,
				fill: "white"
			})
		})
	] })]
});
const ForwardRef = forwardRef(SvgSideDark);
export default ForwardRef;
